function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a6vju2sd6a",
  d: "M0 0h12v12H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "to72eg21zb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a6vju2sd6a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M10.91 10.364a.545.545 0 0 1-.546.545h-6a.545.545 0 0 1-.546-.545v-6c0-.301.244-.546.546-.546h6a.545.545 0 0 1 .545.546v6zM1.09 7.636v-6c0-.3.245-.545.546-.545h6a.545.545 0 0 1 .546.545v1.091H4.363a1.636 1.636 0 0 0-1.636 1.637v3.818h-1.09a.546.546 0 0 1-.546-.545zm9.274-4.909H9.273v-1.09A1.636 1.636 0 0 0 7.636 0h-6A1.636 1.636 0 0 0 0 1.636v6a1.636 1.636 0 0 0 1.636 1.637h1.091v1.09A1.636 1.636 0 0 0 4.364 12h6A1.637 1.637 0 0 0 12 10.364v-6a1.636 1.636 0 0 0-1.636-1.637z",
  fillOpacity: 0.7,
  fill: "#0A131B",
  mask: "url(#to72eg21zb)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M9 6.818H7.91v-1.09a.545.545 0 1 0-1.09 0v1.09H5.726a.545.545 0 1 0 0 1.091h1.091V9A.545.545 0 0 0 7.91 9V7.91H9a.545.545 0 1 0 0-1.092z",
  fillOpacity: 0.7,
  fill: "#0A131B"
}));

var SvgCopyClipboard = function SvgCopyClipboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyClipboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy-clipboard.e8334f12.svg";
export { ForwardRef as ReactComponent };